export default "__VITE_ASSET__746eb176__"